var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.85708 4.805L5.02708 0L0.19708 4.805C0.140093 4.8484 0.0930952 4.90353 0.0592684 4.96667C0.0254416 5.0298 0.00557547 5.09947 0.00101464 5.17096C-0.00354619 5.24244 0.00730509 5.31407 0.0328335 5.38099C0.0583619 5.44792 0.0979715 5.50858 0.148981 5.55886C0.199991 5.60915 0.261209 5.64789 0.328492 5.67246C0.395774 5.69703 0.467551 5.70685 0.538961 5.70127C0.610372 5.69569 0.67975 5.67483 0.742398 5.64011C0.805046 5.60538 0.859502 5.5576 0.90208 5.5L4.52708 1.905V11.47C4.52708 11.6026 4.57976 11.7298 4.67353 11.8236C4.76729 11.9173 4.89447 11.97 5.02708 11.97C5.15969 11.97 5.28687 11.9173 5.38063 11.8236C5.4744 11.7298 5.52708 11.6026 5.52708 11.47V1.905L9.15208 5.5C9.24623 5.59349 9.37367 5.64575 9.50635 5.64528C9.63903 5.64481 9.76609 5.59165 9.85958 5.4975C9.95307 5.40335 10.0053 5.27591 10.0049 5.14323C10.0044 5.01055 9.95123 4.88349 9.85708 4.79V4.805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorUp);
export default __webpack_public_path__ + "static/media/Vector Up.9fa8efd9856e9ae5b1004f4e967aaf3e.svg";
export { ForwardRef as ReactComponent };